export default "__VITE_ASSET__DSUYwyIU__"